import { queryClient, useMutation } from 'query';
import { deleteEventParticipants } from '../../services';
import { getEventParticipantsInfiniteQueryKey, getNodeEventDetailQueryKey } from '../keys';

type DeleteEventParticipantsByEmail = {
  email: string[];
  eventId: string;
};

type DeleteEventParticipantsByRef = {
  eventId: string;
  participantRefs: string[];
};

type DeleteEventParticipantsVariables = DeleteEventParticipantsByEmail | DeleteEventParticipantsByRef;

export const useDeleteEventParticipants = () =>
  useMutation<unknown, DeleteEventParticipantsVariables>({
    async mutationFn({ eventId, ...rest }) {
      const params = 'email' in rest ? { email: { $in: rest.email } } : { ref: { $in: rest.participantRefs } };
      const response = await deleteEventParticipants({
        config: { params },
        routeParams: { eventId },
      });

      return response.data;
    },
    async onSuccess(_, { eventId }) {
      await queryClient.invalidateQueries({ queryKey: getEventParticipantsInfiniteQueryKey({ filter: { eventId } }) });
      await queryClient.invalidateQueries({ queryKey: getNodeEventDetailQueryKey({ eventId }) });
    },
  });
